<div>
    <div class="header">{{ 'bikeshop.users.default_working_hours' | translate }}</div>
    <div class="default-hours-container" *ngIf="defaultWorkHours.id">
        <div>
            <div class="default-hours">
                <div></div>
                <div>{{ 'bikeshop.shop_profile.collections.start_time' | translate }}:<span class="fa fa-info"
                                                                                            pTooltip="{{ 'bikeshop.users.start_time_info' | translate}}"></span>
                </div>
                <div>{{ 'bikeshop.shop_profile.collections.end_time' | translate }}:<span class="fa fa-info"
                                                                                          pTooltip="{{ 'bikeshop.users.end_time_info' | translate}}"></span>
                </div>
                <div>{{ 'bikeshop.users.online_hours' | translate }}:<span class="fa fa-info"
                                                                           pTooltip="{{ 'bikeshop.users.online_time_info' | translate}}"></span>
                </div>
            </div>
            <div class="default-hours">
                <div [ngClass]="{'red' : formatTime(defaultWorkHours.mondayStart) >= formatTime(defaultWorkHours.mondayEnd)}">{{'general.monday' | translate}}
                    <span class="hubtiger-delete"
                          *ngIf="formatTime(defaultWorkHours.mondayStart) != '00:00' && formatTime(defaultWorkHours.mondayEnd) != '00:00'"
                          pTooltip="{{'bikeshop.users.clear_working_hours' | translate}}"
                          (click)="resetHours('MONDAY')"></span></div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.mondayStart) > formatTime(defaultWorkHours.mondayEnd)}"
                            [(ngModel)]="defaultWorkHours.mondayStart" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.mondayStart) > formatTime(defaultWorkHours.mondayEnd)}"
                            [(ngModel)]="defaultWorkHours.mondayEnd" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div class="slider">
                    <div>
                        <p-slider [(ngModel)]="defaultWorkHours.mondayOnline" [step]=1 [min]="0"
                                  [max]="getMaxHours(defaultWorkHours.mondayStart, defaultWorkHours.mondayEnd)"
                                  (onSlideEnd)="defaultUpdated()" [disabled]="loadingCalendar"></p-slider>
                    </div>
                    <span style="margin-left: 16px">{{defaultWorkHours.mondayOnline}}Hrs</span>
                </div>
            </div>
            <div class="default-hours">
                <div [ngClass]="{'red' : formatTime(defaultWorkHours.tuesdayStart) >= formatTime(defaultWorkHours.tuesdayEnd)}">{{'general.tuesday' | translate}}
                    <span class="hubtiger-delete"
                          *ngIf="formatTime(defaultWorkHours.tuesdayStart) != '00:00' && formatTime(defaultWorkHours.tuesdayEnd) != '00:00'"
                          pTooltip="{{'bikeshop.users.clear_working_hours' | translate}}"
                          (click)="resetHours('TUESDAY')"></span></div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.tuesdayStart) > formatTime(defaultWorkHours.tuesdayEnd)}"
                            [(ngModel)]="defaultWorkHours.tuesdayStart" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.tuesdayStart) > formatTime(defaultWorkHours.tuesdayEnd)}"
                            [(ngModel)]="defaultWorkHours.tuesdayEnd" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div class="slider">
                    <div>
                        <p-slider [(ngModel)]="defaultWorkHours.tuesdayOnline" [step]=1 [min]="0"
                                  [max]="getMaxHours(defaultWorkHours.tuesdayStart, defaultWorkHours.tuesdayEnd)"
                                  (onSlideEnd)="defaultUpdated()" [disabled]="loadingCalendar"></p-slider>
                    </div>
                    <span style="margin-left: 16px">{{defaultWorkHours.tuesdayOnline}}Hrs</span>
                </div>
            </div>
            <div class="default-hours">
                <div [ngClass]="{'red' : formatTime(defaultWorkHours.wednesdayStart) >= formatTime(defaultWorkHours.wednesdayEnd)}">{{'general.wednesday' | translate}}
                    <span class="hubtiger-delete"
                          *ngIf="formatTime(defaultWorkHours.wednesdayStart) != '00:00' && formatTime(defaultWorkHours.wednesdayEnd) != '00:00'"
                          pTooltip="{{'bikeshop.users.clear_working_hours' | translate}}"
                          (click)="resetHours('WEDNESDAY')"></span></div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.wednesdayStart) > formatTime(defaultWorkHours.wednesdayEnd)}"
                            [(ngModel)]="defaultWorkHours.wednesdayStart" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.wednesdayStart) > formatTime(defaultWorkHours.wednesdayEnd)}"
                            [(ngModel)]="defaultWorkHours.wednesdayEnd" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div class="slider">
                    <div>
                        <p-slider [(ngModel)]="defaultWorkHours.wednesdayOnline" [step]=1 [min]="0"
                                  [max]="getMaxHours(defaultWorkHours.wednesdayStart, defaultWorkHours.wednesdayEnd)"
                                  (onSlideEnd)="defaultUpdated()" [disabled]="loadingCalendar"></p-slider>
                    </div>
                    <span style="margin-left: 16px">{{defaultWorkHours.wednesdayOnline}}Hrs</span>
                </div>
            </div>
            <div class="default-hours">
                <div [ngClass]="{'red' : formatTime(defaultWorkHours.thursdayStart) >= formatTime(defaultWorkHours.thursdayEnd)}">{{'general.thursday' | translate}}
                    <span class="hubtiger-delete"
                          *ngIf="formatTime(defaultWorkHours.thursdayStart) != '00:00' && formatTime(defaultWorkHours.thursdayEnd) != '00:00'"
                          pTooltip="{{'bikeshop.users.clear_working_hours' | translate}}"
                          (click)="resetHours('THURSDAY')"></span></div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.thursdayStart) > formatTime(defaultWorkHours.thursdayEnd)}"
                            [(ngModel)]="defaultWorkHours.thursdayStart" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.thursdayStart) > formatTime(defaultWorkHours.thursdayEnd)}"
                            [(ngModel)]="defaultWorkHours.thursdayEnd" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div class="slider">
                    <div>
                        <p-slider [(ngModel)]="defaultWorkHours.thursdayOnline" [step]=1 [min]="0"
                                  [max]="getMaxHours(defaultWorkHours.thursdayStart, defaultWorkHours.thursdayEnd)"
                                  (onSlideEnd)="defaultUpdated()" [disabled]="loadingCalendar"></p-slider>
                    </div>
                    <span style="margin-left: 16px">{{defaultWorkHours.thursdayOnline}}Hrs</span>
                </div>
            </div>
            <div class="default-hours">
                <div [ngClass]="{'red' : formatTime(defaultWorkHours.fridayStart) >= formatTime(defaultWorkHours.fridayEnd)}">{{'general.friday' | translate}}
                    <span class="hubtiger-delete"
                          *ngIf="formatTime(defaultWorkHours.fridayStart) != '00:00' && formatTime(defaultWorkHours.fridayEnd) != '00:00'"
                          pTooltip="{{'bikeshop.users.clear_working_hours' | translate}}"
                          (click)="resetHours('FRIDAY')"></span></div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.fridayStart) > formatTime(defaultWorkHours.fridayEnd)}"
                            [(ngModel)]="defaultWorkHours.fridayStart" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.fridayStart) > formatTime(defaultWorkHours.fridayEnd)}"
                            [(ngModel)]="defaultWorkHours.fridayEnd" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div class="slider">
                    <div>
                        <p-slider [(ngModel)]="defaultWorkHours.fridayOnline" [step]=1 [min]="0"
                                  [max]="getMaxHours(defaultWorkHours.fridayStart, defaultWorkHours.fridayEnd)"
                                  (onSlideEnd)="defaultUpdated()" [disabled]="loadingCalendar"></p-slider>
                    </div>
                    <span style="margin-left: 16px">{{defaultWorkHours.fridayOnline}}Hrs</span>
                </div>
            </div>
            <div class="default-hours">
                <div [ngClass]="{'red' : formatTime(defaultWorkHours.saturdayStart) >= formatTime(defaultWorkHours.saturdayEnd)}">{{'general.saturday' | translate}}
                    <span class="hubtiger-delete"
                          *ngIf="formatTime(defaultWorkHours.saturdayStart) != '00:00' && formatTime(defaultWorkHours.saturdayEnd) != '00:00'"
                          pTooltip="{{'bikeshop.users.clear_working_hours' | translate}}"
                          (click)="resetHours('SATURDAY')"></span></div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.saturdayStart) > formatTime(defaultWorkHours.saturdayEnd)}"
                            [(ngModel)]="defaultWorkHours.saturdayStart" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.saturdayStart) > formatTime(defaultWorkHours.saturdayEnd)}"
                            [(ngModel)]="defaultWorkHours.saturdayEnd" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div class="slider">
                    <div>
                        <p-slider [(ngModel)]="defaultWorkHours.saturdayOnline" [step]=1 [min]="0"
                                  [max]="getMaxHours(defaultWorkHours.saturdayStart, defaultWorkHours.saturdayEnd)"
                                  (onSlideEnd)="defaultUpdated()" [disabled]="loadingCalendar"></p-slider>
                    </div>
                    <span style="margin-left: 16px">{{defaultWorkHours.saturdayOnline}}Hrs</span>
                </div>
            </div>
            <div class="default-hours">
                <div [ngClass]="{'red' : formatTime(defaultWorkHours.sundayStart) >= formatTime(defaultWorkHours.sundayEnd)}">{{'general.sunday' | translate}}
                    <span class="hubtiger-delete"
                          *ngIf="formatTime(defaultWorkHours.sundayStart) != '00:00' && formatTime(defaultWorkHours.sundayEnd) != '00:00'"
                          pTooltip="{{'bikeshop.users.clear_working_hours' | translate}}"
                          (click)="resetHours('SUNDAY')"></span></div>
                <div>
                    <p-calendar
                            [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.sundayStart) > formatTime(defaultWorkHours.sundayEnd)}"
                            [(ngModel)]="defaultWorkHours.sundayStart" [timeOnly]="true" [hourFormat]="'24'"
                            inputId="timeonly"
                            [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div>
                    <p-calendar [defaultDate]="defaultDate"
                                [ngClass]="{'invalid-time' : formatTime(defaultWorkHours.sundayStart) > formatTime(defaultWorkHours.sundayEnd)}"
                                [(ngModel)]="defaultWorkHours.sundayEnd" [timeOnly]="true" [hourFormat]="'24'"
                                inputId="timeonly"
                                [stepMinute]="5" (onClose)="defaultUpdated()" [disabled]="loadingCalendar"></p-calendar>
                </div>
                <div class="slider">
                    <div>
                        <p-slider [(ngModel)]="defaultWorkHours.sundayOnline" [step]=1 [min]="0"
                                  [max]="getMaxHours(defaultWorkHours.sundayStart, defaultWorkHours.sundayEnd)"
                                  (onSlideEnd)="defaultUpdated()" [disabled]="loadingCalendar"></p-slider>
                    </div>
                    <span style="margin-left: 16px">{{defaultWorkHours.sundayOnline}}Hrs</span>
                </div>
            </div>
        </div>
    </div>

    <div class="header margin-top-16">{{ 'bikeshop.users.configured_working_hours' | translate }}</div>
    <div style="display: -webkit-inline-box;align-items: flex-start;">
        <app-availability-calendar [fromDate]="fromDate" [toDate]="toDate" [configuredWorkHours]="configuredWorkHours"
                                   (updateDateSelected)="updateDateSelected($event)"
                                   (getMonthData)="getMonthData($event)" [loading]="loadingCalendar"
                                   [showFunctionalityInfo]="true"></app-availability-calendar>
        <div class="custom-date" *ngIf="selectedDate">
            <div class="date">{{selectedDate.date | date : "dd MMM yyyy"}}</div>
            <div class="custom-hours-container">
                <div>
                    <div class="default-hours">
                        <div></div>
                        <div>{{ 'bikeshop.shop_profile.collections.start_time' | translate }}:</div>
                        <div>{{ 'bikeshop.shop_profile.collections.end_time' | translate }}:</div>
                        <div>{{ 'bikeshop.users.online_hours' | translate }}:</div>
                    </div>
                    <div class="default-hours">
                        <div></div>
                        <div>
                            <p-calendar
                                    [ngClass]="{'invalid-time' : formatTime(selectedDate.startTime) > formatTime(selectedDate.endTime)}"
                                    [(ngModel)]="selectedDate.startTime" [timeOnly]="true" [hourFormat]="'24'"
                                    inputId="timeonly"
                                    [stepMinute]="5" (onClose)="actualUpdated()"></p-calendar>
                        </div>
                        <div>
                            <p-calendar
                                    [ngClass]="{'invalid-time' : formatTime(selectedDate.startTime) > formatTime(selectedDate.endTime)}"
                                    [(ngModel)]="selectedDate.endTime" [timeOnly]="true" [hourFormat]="'24'"
                                    inputId="timeonly"
                                    [stepMinute]="5" (onClose)="actualUpdated()"></p-calendar>
                        </div>
                        <div class="slider">
                            <div>
                                <p-slider [(ngModel)]="selectedDate.onlineHours" [step]=1 [min]="0"
                                          [max]="getMaxHours(selectedDate.startTime, selectedDate.endTime)"
                                          (onSlideEnd)="actualUpdated()"></p-slider>
                            </div>
                            <span style="margin-left: 16px">{{selectedDate.onlineHours}}Hrs</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
